import { TooltipRenderProps } from 'react-joyride';

export const CustomTooltip = ({ step, backProps, closeProps, primaryProps, skipProps, index, size, isLastStep, tooltipProps }: TooltipRenderProps) => {
  // Use absolute display values injected by useTourSteps so the counter always shows
  // the correct position across the full tour (e.g. "3 / 5") even when the steps
  // array has been sliced after a close-and-resume.
  const displayIndex: number = (step.data as any)?.displayIndex ?? index;
  const displayTotal: number = (step.data as any)?.displayTotal ?? size;

  return (
    <div
      {...tooltipProps}
      style={{ ...(tooltipProps as any).style }}
      className='bg-[#1C2429] rounded-lg text-white flex flex-col max-w-[420px] min-w-[300px] p-16 z-[10000]'
    >
      {/* Header: Step Counter + Close */}
      <div className='flex justify-end items-center mb-12'>
        {step.title && <h3 className='m-0 text-base font-semibold'>{step.title}</h3>}
        <div className='flex items-center gap-3'>
          <span className='text-12 text-white'>
            {displayIndex + 1} / {displayTotal}
          </span>
          <button
            {...closeProps}
            title='Close'
            className='bg-transparent border-0 text-[#9CA3AF] cursor-pointer text-base p-0 flex items-center hover:text-white transition-colors'
          >
            ✕
          </button>
        </div>
      </div>

      {/* Content */}
      <div className='text-14 text-grey-40'>{step.content}</div>

      {/* Footer: Skip + Nav Buttons */}
      <div className='flex justify-between items-center mt-24'>
        <button {...skipProps} className='bg-transparent border-0 text-neutral-70 cursor-pointer text-12 hover:text-[#D1D5DB] transition-colors'>
          Skip Tour
        </button>
        <div className='flex gap-8'>
          {index > 0 && (
            <button {...backProps} className='bg-transparent border-0 text-grey-40 cursor-pointer text-14 px-16 py-8 hover:text-white transition-colors'>
              Back
            </button>
          )}
          <button
            {...primaryProps}
            className='bg-primary border-none rounded text-white cursor-pointer text-sm font-medium px-16 py-8 hover:bg-[#008f28] transition-colors'
          >
            {isLastStep ? 'Finish' : 'Next Step'}
          </button>
        </div>
      </div>
    </div>
  );
};
